import styled from 'styled-components';
import CommonColumn from '../../common/Column';

const Column = styled(CommonColumn)`
    display: inline-flex;
    justify-content: center;
    align-items: center;
`;

export default Column;
